<div class="holidays-popup">
    <h2 align="center">Saremo chiusi per ferie</h2>
    <p>dal {{ startingDate | date: 'dd/MM/yyyy' }} fino al {{ targetDate | date:'dd/MM/yyyy' }} compreso.</p>
    <button class="btn btn-primary" (click)="closePopup()">Chiudi</button>
</div>
